/* eslint-disable */
import { ArrowBack } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useProductData, useQuery } from '@/Helpers';
import Info from '@/Components/InfoTab/Info';
import { formActions } from '@/Actions';
import { Input, MultiCascader } from 'rsuite';
import config from './productMapConfig';
import allVendorServices from '@/Services/Form Services/allvendor.services';
import { urls } from '@/Constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { notificationServices } from '@/Services/Notification';
import TableDynamic from '@/Components/TableDynamic/tableDynamic';

const headers = [
		{
			colName: 'UY Id',
			id: 'variantId',
			bgColor: '#94a3b8',
			custom: false,
		},
		{
			colName: 'Products',
			id: 'productName',
			bgColor:'#e5e7eb',
			custom: true,
		},
		{
			colName: 'Unit',
			bgColor: '#94a3b8',
			id: 'unit',
			custom:false,
		},
		{
			colName: 'Buyer System item ID',
			id: 'buyerSystemItemId',
			bgColor: '#94a3b8',
			custom: true,
		},
];


const productHeaders = ['Category', 'Product', 'Variant'];
function ProductMap() {
	const query = useQuery();
	const buyerId = query?.get('id');
	const view = query?.get('view');
	const add = query?.get('add');
	const edit = query?.get('edit');
	const history = useHistory();
	const buyersData = useSelector((state) => state.form.ALL_BUYERS.data.LIST);
	const buyerInfo = buyersData?.find((ele) => ele?.id == buyerId);
	const [buyerDetailsInfo, setBuyerDetailsInfo] = useState({});
	const [data, setData] = useState([]);	
	const [value, setValue] = useState([]);
	const [flatData, setFlatData] = useState([]);
	const dispatch = useDispatch();
	const productsList = useSelector((state) => state?.form?.ALL_PRODUCTS?.data?.LIST);
	const productCategoriesList = useSelector((state) => state?.form?.PRODUCT_CATEGORY?.data?.LIST);

	useEffect(() => {
		if(buyerId){
			setBuyerDetailsInfo({
				buyerName: buyerInfo?.name ?? '-',
				legalName: buyerInfo?.legalName ?? '-',
				gstin: buyerInfo?.gstin ?? '-',
				paymentTermCode: buyerInfo?.paymentTermCode ?? '-',
				vendorType: buyerInfo?.vendorType ?? '-',
				subType: buyerInfo?.subType ?? '-',
			});
		}
		if(productsList?.length === 0 || !productsList){
			useProductData(dispatch);
		}
		dispatch(formActions.gateway({
			entity: 'PRODUCT_CATEGORY',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		}));
	},[buyerId]);

	useEffect(async () => {
		if(buyerId && (view === 'true' || edit === 'true')){
			try{
			const response = await allVendorServices?.buyerProductMap({
				params: {
					vendor: buyerId,
				},
			}, 'GET');
				if(response?.statusCode == 200){
					const data = response?.data;
					const processedData = config?.serializer(data, productsList);
					setFlatData(processedData);
					setValue(processedData?.map((item) => item?.variantId));
				}
			} catch(error){
			}
		}
	}, [view, edit]);

	useEffect(() => {
		if (productsList && productCategoriesList) {
			const categoryToProductMapping = {};
			const productToVariantMapping = {};
			const tmpVariants = {};
			const catChildren = {};
			productsList?.forEach((product) => {
				if (product.skuType === 'PRODUCT') {
					const prodChildren = {};
					// eslint-disable-next-line prefer-template
					const productId = 'p-' + product?.id;
					product?.variants?.forEach((variant) => {
						const item = {
							productId: product?.id,
							productName: product?.productName,
							variantId: variant?.id,
							variantName: variant?.displayName,
							unit: product?.purchaseUnit ?? product?.unit,
							buyerSystemItemId: '',
							active: true,
							buyerId: buyerId

						};
						tmpVariants[variant?.id] = item;
						if (productId in prodChildren) {
							productToVariantMapping[productId].push(item);
							prodChildren[productId].push({
								label: variant?.displayName,
								value: variant?.id,
							});
						} else {
							productToVariantMapping[productId] = [item];
							prodChildren[productId] = [{
								label: variant?.displayName,
								value: variant?.id,
							}];
						}
					});
					// eslint-disable-next-line prefer-template
					const categoryId = 'c-' + product?.categoryId;
					if (categoryId in catChildren) {
						categoryToProductMapping[categoryId].push(...productToVariantMapping[productId] ?? []);
						catChildren[categoryId].push({
							label: product?.productName,
							value: productToVariantMapping[productId],
							children: prodChildren[productId],
						});
					} else {
						categoryToProductMapping[categoryId] = [...productToVariantMapping[productId] ?? []];
						catChildren[categoryId] = [
							{
								label: product?.productName,
								value: productToVariantMapping[productId],
								children: prodChildren[productId],
							},
						];
					}
				}
			});

			const tempData = [];
			productCategoriesList?.forEach((category) => {
				// eslint-disable-next-line prefer-template
				const categoryId = 'c-' + category?.id;
				if (categoryToProductMapping[categoryId]?.length > 0) {
					const obj = {
						label: category?.productCategoryName,
						value: categoryToProductMapping[categoryId],
						children: catChildren[categoryId],
					};
					tempData.push(obj);
				}
			});
			setData(tempData);
		}
	}, [productsList, productCategoriesList]);

	const handleSave = async () => {
		let notificationId;
		// const errors = config?.validation(flatData);
		// if (errors && typeof errors === 'object' && Object.keys(errors).length > 0) {
		// 	Object.entries(errors).forEach(([key, value]) => {
		// 		notificationServices?.generateNotification({
		// 			type: 'warning',
		// 			message: `${value} at Line number ${key + 1}`,
		// 		});
		// 	});
		// }
		notificationId = notificationServices?.generateNotification({
				type: 'loading',
				message: 'loading....',
		});
		try{
			const data = config?.deserializer(flatData, edit);
			const res =await allVendorServices?.buyerProductMap({
				data:{
					data : data,
				},
				params: {
					vendor: buyerId,
				},
			});
			if(res?.statusCode == 200){
				notificationServices?.generateNotification({
					type: 'success',
					message: edit ? 'Data updated successfully' : 'Data saved successfully',
					config: {
						id: notificationId,
					}
				});
				if(add){
					history.push(history?.location?.state?.prevPath);
					return
				}
				if (edit){
					history.push({
						pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
						search: `?id=${buyerId}&view=true`,
						state: {
							prevPath: history?.location?.state?.prevPath,
						},
					});
				}
			}else{
				notificationServices?.generateNotification({
					type: 'error',
					message: 'Something went wrong',
					config: {
						id: notificationId,
					}
				});
			}
		}catch(error){
			console.log(error, 'error');
		}
	};

	const fieldMap = {
		'Buyer Name': 'buyerName',
		'Legal Name': 'legalName',
		'GSTIN': 'gstin',
		'Payment Term': 'paymentTermCode',
		'Buyer Type': 'vendorType',
		'Buyer Sub Type' : 'subType',
	};

	const Column = ({ header, children }) => {
		return (
			<div>
				<div
					style={{
						background: '#154c94',
						padding: '4px 10px',
						color: ' #fff',
						textAlign: 'center',
					}}
				>
					{header}
				</div>
				{children}
			</div>
		);
	};

	const handleUpdateRow = (value, rowData) => {
		const tmpFlatData = [...flatData];
		tmpFlatData.forEach((row) => {
			if(row?.variantId == rowData?.variantId){
				row.buyerSystemItemId = value;
			}
		});
		setFlatData(tmpFlatData);
	};

	const findVariantById = (id) => {
		return productsList?.find((product) => product?.variants?.some((variant) => variant?.id == id))?.variants?.find((variant) => variant?.id == id);
	}
	const findProductByVariant = (id) => {
		return productsList?.find((product) => product?.variants?.some((variant) => variant?.id == id));
	}

	const handleChange = (value) => {
		if(edit === 'true'){
			const newSelectedIds = Array.from(
				new Set(
				  value?.flat()?.map((item) => {
					if (typeof item === 'object' && item !== null) {
					  return item?.variantId;
					}
					return item;
				  })
				)
			  );
			  const existingIds = flatData.map((item) => item.variantId);
			  const newlyAdded = newSelectedIds.filter((id) => !existingIds.includes(id));
		  
			  const newVariants = newlyAdded.map((id) => {
				const variant = findVariantById(id);
				const product = findProductByVariant(id);
		  
				return {
				  variantId: variant?.id,
				  productId: product?.id,
				  productName: product?.productName,
				  variantName: variant?.displayName,
				  unit: product?.purchaseUnit ?? product?.unit,
				  buyerSystemItemId: '',
				  active: true,
				  buyerId:buyerId,
				};
			  });
		  
			  // Preserve existing data for the already selected variants
			  const preservedData = flatData.filter((item) =>
				newSelectedIds.includes(item.variantId)
			  );
		  
			  // Final merged list: new on top + existing preserved
			  const finalData = [...newVariants, ...preservedData];
		  
			  // Update state
			  setFlatData(finalData);
			  setValue(newSelectedIds); // if needed for form
			}
		else{
			const flatValue = value?.flat();
			const selectedVariantIds = Array.from(
				new Set(
				  flatValue.map((item) =>
					typeof item === 'object' ? item.variantId : item
				  )
				)
			  );
			const existingIds = flatData.map((item) => item.variantId);
			const newIds = selectedVariantIds.filter(id => !existingIds.includes(id));
			const newFlatEntries = [];
		
			newIds.forEach((id) => {
			  for (const product of productsList) {
				const variant = product.variants?.find(v => v.id === id);
				if (variant) {
				  newFlatEntries.push({
					variantId: variant.id,
					productId: product.id,
					productName: product.productName,
					variantName: variant.displayName,
					unit: product.purchaseUnit ?? product.unit,
					buyerSystemItemId: '',
					active: true,
					buyerId: buyerId,
				  });
				  break;
				}
			  }
			});
			const preservedData = flatData.filter((item) =>
				selectedVariantIds.includes(item.variantId)
			  );
			const updatedFlatData = [...preservedData, ...newFlatEntries];
			setFlatData(updatedFlatData);
			setValue(selectedVariantIds);
		  }
	};

	const customRenderCell = (row, key, header, rowIndex, cellIndex) => {
		if(header?.id === 'productName'){
			return <div>{row?.productName} ({row?.variantName})</div>;
		}
		if(header?.id === 'buyerSystemItemId'){
			return row?.active ? <Input 
									type='text'
									className='w-full' 
									value={row?.buyerSystemItemId} 
									onChange={(value) => handleUpdateRow(value, row)} 
									disabled={view}
									/> : <Input 
									type='text'
									className='w-full' 
									value={row?.buyerSystemItemId} 
									onChange={(value) => handleUpdateRow(value, row)} 
									disabled
									/>;
		}

	};

	const handleToggleRow = (row) => {
		const tmpFlatData = [...flatData];
		tmpFlatData.forEach((rowData) => {
			if(row?.variantId == rowData?.variantId){
				rowData.active = !rowData.active;
			}
		});
		setFlatData(tmpFlatData);
	}

	const handleEdit =() => {
		history.push({
			pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
			search: `?id=${buyerId}&edit=true`,
			state: {
				prevPath: history?.location?.state?.prevPath,
			},
		});
	}
	const handleView = () =>{
		history.push({
			pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
			search: `?id=${buyerId}&view=true`,
			state: {
				prevPath: history?.location?.state?.prevPath,
			},
		});
	}

	return (
		<div>
			{/* header */}
			<div className='flex items-center justify-between p-4'>
				<div className='flex items-center gap-2'>
					<ArrowBack onClick={() => history.push(history?.location?.state?.prevPath)} className='cursor-pointer'/>
					<span className='font-[500] text-[17px]'>Item Mapping with Buyer’s System</span>
				</div>
				{add === 'true' ? (
					<button
						id='save-btn'
						onClick={handleSave}
						className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors'
					>
						Save
					</button>
				) : view === 'true' ? (
					<button id='edit-btn' onClick={() => handleEdit()} className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors'>
						Edit
					</button>
				) : (
					<div className='flex flex-row align-center gap-2'>
					<button id='view-btn' onClick={() => handleView()} className='bg-slate-500 text-white px-4 py-2 rounded hover:bg-slate-700 transition-colors'>
						View
					</button>
					<button
						id='save-btn'
						onClick={handleSave}
						className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors'
					>
						Save
					</button>
					</div>
				)}
			</div>
			<Info
                fieldMap={fieldMap}
                data={buyerDetailsInfo} 
				colNo={6}
				padding={4}
				top={0}
            />
			<div className='px-4'>
			<div className='flex flex-row justify-start gap-3 items-center mb-2'>
				<div>Select Products</div>
            	<MultiCascader
                	data={data}
                	value={value}
                	onChange={handleChange}
                	block
                	columnWidth={220}
                	style={{ width: 300}}
                	renderColumn={(childNodes, { layer }) => (
                    	<Column header={productHeaders[layer]}>
                        	{childNodes}
                    	</Column>
                	)}
                	placeholder={<span>Products</span>}
                	renderValue={() => (
                    	<span>
                        	<span>Update Products</span>
                    	</span>
                	)}
					disabled={view}
            	/>
			</div>
			<div className='w-full overflow-auto' style={{maxHeight: '60vh'}}>
			<TableDynamic
				headers={headers}
				rows={flatData}
				renderCell={customRenderCell}
				showRowToggle
				handleToggle={handleToggleRow}
				cellStyle={{
					fontSize: '12px',
					textAlign: 'left',
				}}
				disableEditableField={view}
			/>
			</div>
			</div>
		</div>
	);
}
export default ProductMap;
